import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=328c4d4c&"
import script from "./BarChart.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports